<template>
  <section
    class="relative text-center text-white py-16 bg-cover bg-no-repeat px-4"
    :class="videoSrc ? 'bg-[#35095b]' : props.backgroundClass || 'bg-[#5f4ca4] '"
  >
    <!-- Looping video background (a caller's own, or the default webm):
         rendered behind the content, it replaces the CSS background. -->
    <video
      v-if="videoSrc"
      class="absolute inset-0 w-full h-full object-cover"
      :src="videoSrc"
      autoplay
      muted
      loop
      playsinline
      preload="auto"
      aria-hidden="true"
    ></video>
    <!-- The white scalloped strips belong to the photo background; a themed
         backgroundClass replaces both. -->
    <div
      :class="[
        'max-w-screen-lg mx-auto',
        videoSrc ? 'relative z-10' : '',
        !videoSrc
          ? `after:content-[''] after:block after:absolute after:left-0 after:top-0 after:w-full after:h-2 after:bg-[url('/images/hlaf-white-circle.webp')] dark:after:bg-none dark:before:bg-none after:bg-repeat-x before:content-[''] before:block before:absolute before:left-0 before:bottom-0 before:rotate-180 before:w-full before:h-2 before:bg-[url('/images/hlaf-white-circle.webp')] before:bg-repeat-x`
          : '',
      ]"
    >
      <h2 class="text-4xl lg:text-5xl text-center font-semibold mb-3">
        {{ props.heading }}
      </h2>
      <p class="mb-6 md:text-lg tracking-[0.5px] lg:px-32">
        {{ props.paragraphText }}
      </p>
      <button
        @click="openModal"
        class="bg-[#fff] text-[#5f4ca4] p-[7px_15px] text-base rounded-[4px] font-medium"
        v-if="props.changeContent"
      >
        {{ props.buttonText }}
      </button>
      <WrButton
        container-class="mx-auto"
        @click="scroll ? handleScroll() : openModal()"
        v-else
        >{{ props.buttonText }}</WrButton
      >
    </div>

    <Teleport to="body">
      <WrContactFormPopup v-if="visible" :isOpen="visible" @close="visible = false" class="z-30" />
    </Teleport>
  </section>
</template>

<script setup>
import { Teleport } from "vue";

const props = defineProps({
  heading: {
    type: String,
    required: false,
    default: "The WebReinvent' team works 100% remotely.",
  },
  buttonText: {
    type: String,
    required: false,
    default: "Get Free Quote",
  },
  paragraphText: {
    type: String,
    required: false,
    default: "A diverse team to solve your diverse Laravel challenges.",
  },
  changeContent: {
    type: Boolean,
    required: false,
    default: false,
  },
  // Optional themed background (e.g. a gradient class) that replaces the
  // default photo background and its white scalloped strips.
  backgroundClass: {
    type: String,
    required: false,
    default: "",
  },
  // Optional looping background video (e.g. /videos/xxx.webm). When set it is
  // rendered behind the content and replaces the CSS background image.
  backgroundVideo: {
    type: String,
    required: false,
    default: "",
  },
  scroll: {
    type: Boolean,
    required: false,
    default: false,
  },
});
const visible = ref(false);

// Looping background video: a caller can pass its own; otherwise the default
// webm is used whenever there's no themed background to show.
const videoSrc = computed(() =>
  props.backgroundVideo ||
  (!props.backgroundClass && !props.changeContent
    ? "/videos/wrBannerCta.webm"
    : "")
);

const emit = defineEmits(["handleClick"]);

const handleScroll = () => {
  emit("handleClick");
};

const openModal = () => {
  visible.value = true;
};
</script>
